import { createContext, useCallback, useMemo, useState } from 'react';

export const CampaignContext = createContext({});
export const CampaignContextProvider = ({ children, props }) => {
   const [step, setStep] = useState(1);
   
   const [selectedCampaign, setSelectedCampaign] = useState([]);
   const [viewingCampaign, setViewingCampaign] = useState(null);
   
   const [saving, setSaving] = useState(false);
   const [campaignType, setCampaignType] = useState('email' || null);
   const [campaignName, setCampaignName] = useState('a' || null);
   const [campaignFromName, setCampaignFromName] = useState('a' || null);
   const [campaignFromEmail, setCampaignFromEmail] = useState('a' || null);
   const [campaignSubject, setCampaignSubject] = useState('a' || null);
   const [campaignTemplate, setCampaignTemplate] = useState(null);
   const [campaignSmsTemplate, setCampaignSmsTemplate] = useState('Generic');
   const [campaignRecipientLists, setCampaignRecipientLists] = useState([]);
   const [campaignRecipientContacts, setCampaignRecipientContacts] = useState([]);
   const [deliveryDate, setDeliveryDate] = useState(null);
   const [deliveryTime, setDeliveryTime] = useState(null);
   const [batchDelivery, setBatchDelivery] = useState(true);
   const [batchCount, setBatchCount] = useState(2);
   const [batchTime, setBatchTime] = useState(5);
   const [timewarpDelivery, setTimewarpDelivery] = useState(true);
   const [aiDelivery, setAiDelivery] = useState(false);
   const [recurringType, setRecurringType] = useState('once');
  
  return (
    <CampaignContext.Provider
      value={{
        actions: {
           setSelectedCampaign,
           setViewingCampaign,
           setSaving,
           setCampaignType,
           setCampaignName,
           setCampaignFromName,
           setCampaignFromEmail,
           setCampaignSubject,
           setCampaignTemplate,
           setCampaignSmsTemplate,
           setCampaignRecipientLists,
           setCampaignRecipientContacts,
           setStep,
           setDeliveryDate,
           setDeliveryTime,
           setBatchDelivery,
           setBatchCount,
           setBatchTime,
           setTimewarpDelivery,
           setAiDelivery,
           setRecurringType,
        },
        state: {
           selectedCampaign,
           saving,
           campaignType,
           campaignName,
           campaignSubject,
           campaignTemplate,
           campaignSmsTemplate,
           campaignRecipientLists,
           campaignRecipientContacts,
           campaignFromName,
           campaignFromEmail,
           step,
           viewingCampaign,
           deliveryDate,
           deliveryTime,
           batchDelivery,
           batchCount,
           batchTime,
           timewarpDelivery,
           aiDelivery,
           recurringType,
        }
      }}
      {...props}
    >
      {children}
    </CampaignContext.Provider>
  );
};
